import { useEffect } from 'react';

// ----------------------------------------------------------------------

/**
 * A browser changes a focused number field when the mouse wheel turns over it, so a seller who
 * scrolls the page with the cursor over a quantity or price field edits it without noticing (a
 * quantity of 1 becomes -3). Taking focus off the field as the wheel turns lets the page scroll
 * and leaves the value as typed.
 *
 * @param {WheelEvent} event
 */
export function stopWheelChangingNumberField(event) {
  const field = event.target;
  if (field instanceof HTMLInputElement && field.type === 'number' && field === document.activeElement) {
    field.blur();
  }
}

/** Applies stopWheelChangingNumberField to every number field in the app. Mounted once, in App. */
export function useNumberInputsIgnoreScroll() {
  useEffect(() => {
    document.addEventListener('wheel', stopWheelChangingNumberField, { passive: true });
    return () => document.removeEventListener('wheel', stopWheelChangingNumberField);
  }, []);
}
